<div class="explore-minds-card-container" (click)="openModal.emit()">
    <img src="{{ exploreMindCardInfo.mindCardIcon }}" alt="" />
    <div class="explore-minds-card-container__description">
        <h4>{{ exploreMindCardInfo.title }}</h4>
        <p>{{ exploreMindCardInfo.description }}</p>
    </div>
</div>
